let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("39JYF")).then(() => parcelRequire('jg2EL'));